export namespace MyApp
{
    export enum Environment
    {
        Prod,
        Staging,
        Dev,
        Test
    }

    export enum HttpResponseStatusCode
    {
        Offline = 0,
        BadRequest = 400,
        Unauthorized = 401,
        Forbidden = 403
    }

    export enum SortOrder
    {
        Ascending,
        Descending
    }

    export enum AppSection
    {
        Unknown,
        News,
        Events,
        Notifications,
        Members,
        Albums,
        Contacts,
        Categories,
        OrganizationInfo,
        Locations,
        Sponsors,
        Themes,
    }

    export enum DocumentType
    {
        None,
        TermsOfService,
        PrivacyPolicy,
        FAQ,
    }

    export enum AssetType
    {
        Image = 1,
        Video = 2
    }

    export enum RecurrenceType
    {
        Never = -1,
        Daily = 0,
        Weekly = 1,
        Monthly = 2,
        Yearly = 3
    }

    export enum NotificationType
    {
        Email = 1,
        Push = 2,
    }

    export enum SocialMediaAccountType
    {
        Facebook = 1,
        Twitter = 2,
    }

    export enum ProductFeatureFlags
    {
        ProfessionalInfo = 0x01,
        Sponsor = 0x02,
        Staff = 0x04,
        HoursOfOperation = 0x08,
        GuestLoginPassword = 0x10,
        GuestLoginAnonymous = 0x20
    }
}
